/*  ==========================================================================
    DYNAMIC FILELOADER
    Load external resources dynamicly (js, css, ...) and with optional
    callback function.

    CONFIG:
    1) long variant (as object) with addtional attributes:
    '''
        var configObject = {
            nameOfSource: {
                src: 'path/to/source',
                callback: function () { *do something* }
            }
        };
    '''
    2) short variant (as string) with defaults:
    '''
        var configObject = {
            nameOfSource: 'path/to/source'
        };
    '''
    ========================================================================== */

/**
 * Helper function which adds a callback to a given tag
 *
 * @param tag
 * @param {function} callback
 * @param {string} type
 */
function addCallbackToTag(tag, callback, type) {
    if (!(type === 'load' || type === 'error')) {
        return;
    }
    if (typeof callback !== 'function') {
        return;
    }
    tag.addEventListener(type, callback);
}

/**
 * Function which creates the specific tag
 * and create event for a custom callback
 * (intended for internal use only)
 *
 * @param {Object} config - configuration for the tag
 */
let tagCreator = function (config) {
    let tag;
    // create the specific html tag
    if (config.type === 'js') {
        tag = document.createElement('script');
        tag.src = config.src;
        tag.async = true;
    } else if (config.type === 'css') {
        tag = document.createElement('link');
        tag.href = config.src;
        tag.media = config.media;
        tag.rel = 'stylesheet';
    }
    // append tag in body area
    if (typeof tag !== 'undefined') {
        // trigger a callback if given
        const attributes = config.attributes || {};
        Object.keys(attributes).forEach(function(attrKey) {
            const attrValue = attributes[attrKey];
            tag.setAttribute(attrKey, attrValue);
        });

        addCallbackToTag(tag, config.onLoad, 'load');
        addCallbackToTag(tag, config.onError, 'error');

        if (document && document.body) {
            document.getElementsByTagName('body')[0].appendChild(tag);
        }
        console.log('DYN-FILE-LOADER');
        console.log('new script or style tag was inserted in body');
        console.log(tag);
    }
};

/**
 * This function should be used in
 * your code to load things
 *
 * @param {Object} obj
 * @param {string} type
 */
let load = function (obj, type) {
    for(let item in obj) {
        if(obj.hasOwnProperty(item)) {
            // defaults
            let src = '';
            let media = 'screen';
            let onLoad = function () {};
            let onError = function () {};
            let attributes = {};

            // if the 'object' is a string, use it as source directly
            if (typeof obj[item] === typeof '')
                src = obj[item];
            else {
                src = obj[item].src;
                media = obj[item].media || media;
                onLoad = obj[item].onLoad || onLoad;
                onError = obj[item].onError || onError;
                attributes = obj[item].attributes || {};
            }
            // create the tag with the previous fetched values
            tagCreator({
                src,
                type,
                media,
                onLoad,
                onError,
                attributes,
            });
        }
    }
};

// export the functions in es6 style
export { load }


// WEBPACK FOOTER //
// ./source/js/utilities/lib/dyn-file-loader.js